import { render, staticRenderFns } from "./injured.vue?vue&type=template&id=1d1a04f8&"
import script from "./injured.vue?vue&type=script&lang=js&"
export * from "./injured.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports